import { Button as Btn, ButtonProps } from '@mis/sushi-tailwind-react';
import * as React from 'react';
import { DeleteButton } from './delete-button/DeleteButton';
import { GreenButton } from './green-button/GreenButton';
import { LinkButton } from './link-button/LinkButton';
import { ListButton } from './list-button/ListButton';
import { MiddleDarkButton } from './middle-dark-button/MiddleDarkButton';
import { PrimaryButton } from './primary-button/PrimaryButton';
import { RedButton } from './red-button/RedButton';
import { SecondaryButton } from './secondary-button/SecondaryButton';
import { TransparentButton } from './transparent-button/TransparentButton';

interface OverrideButtonInterface extends React.FC<ButtonProps> {
  Primary: typeof PrimaryButton;
  Secondary: typeof SecondaryButton;
  Green: typeof GreenButton;
  Transparent: typeof TransparentButton;
  Delete: typeof DeleteButton;
  Link: typeof LinkButton;
  ListButton: typeof ListButton;
  MiddleDark: typeof MiddleDarkButton;
  Red: typeof RedButton;
}

const Button: OverrideButtonInterface = (props) => {
  return <Btn type="button" {...props} />;
};

Button.displayName = 'OverrideButton';
Button.Primary = PrimaryButton;
Button.Secondary = SecondaryButton;
Button.Green = GreenButton;
Button.Transparent = TransparentButton;
Button.Delete = DeleteButton;
Button.Link = LinkButton;
Button.ListButton = ListButton;
Button.MiddleDark = MiddleDarkButton;
Button.Red = RedButton;

export default Button;
